export default { sha: '01719cf8e1aac6f5335eaa8e555c10d0d77825bb', buildNumber: 'undefined' }
